export const exploreQueryStringSafeguard = (queryString) => {
    const safePaths = [/^\/explore$/, /^\/project\/\d+\/vendors$/];
    if (!safePaths.some((rx) => rx.test(window.location.pathname))) {
        return;
    }
    const newUrl = `${window.location.pathname}?${queryString}`;
    window.history.pushState(null, '', newUrl);
};
